export default class GenerateMemberCardsAbstractServices {
  static getLastOrder(memberNumber) {
    logger.error(`GenerateMemberCards:: getLastOrder(${memberNumber}) not implemented`);
  }

  static getPostalAddress(memberNumber) {
    logger.error(`GenerateMemberCards:: getPostalAddress(${memberNumber}) not implemented`);
  }

  static submitNewCardOrder(contactId, memberNumber, numberOfCards) {
    logger.error(`GenerateMemberCards:: submitNewCardOrder(${contactId}, ${memberNumber}, ${numberOfCards}) not implemented`);
  }

  static getReferenceData() {
    logger.error(`GenerateMemberCards:: getReferenceData() not implemented`);
  }
}
